<dhp-article-purchase-account-shell
  [eyebrowKey]="'pages.articlePurchase.accountUpdate.eyebrow'"
  [titleKey]="'pages.articlePurchase.accountUpdate.title'"
  [descriptionKey]="'pages.articlePurchase.accountUpdate.description'"
  [noticeKey]="'pages.articlePurchase.accountUpdate.notice'"
>
  <form
    class="flex flex-col gap-6"
    [formGroup]="formGroup"
    (ngSubmit)="submit()"
  >
    <div class="grid gap-4 md:grid-cols-2">
      @for (field of fields; track field.formControlName) {
        <dhp-input-field [field]="field"></dhp-input-field>
      }
    </div>

    @if (errorKey()) {
      <div class="rounded-xl bg-error-light p-4 text-error-text">
        {{ errorKey()! | translate }}
      </div>
    }

    <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
      @if (articleId()) {
        <a
          class="btn-secondary btn sm:w-fit"
          [routerLink]="['/articles', articleId()]"
        >
          {{ 'pages.articlePurchase.backToArticle' | translate }}
        </a>
      }

      <dhp-submit-button
        class="sm:w-fit"
        [disabled]="submitting()"
        [labelKey]="'pages.articlePurchase.accountUpdate.submit'"
        [sendingLabelKey]="'pages.articlePurchase.accountUpdate.submitting'"
        [sending]="submitting()"
      ></dhp-submit-button>
    </div>
  </form>
</dhp-article-purchase-account-shell>
